import { render } from "./UserHistory.vue?vue&type=template&id=78bbdcf5&scoped=true&ts=true"
import script from "./UserHistory.vue?vue&type=script&lang=ts"
export * from "./UserHistory.vue?vue&type=script&lang=ts"

import "./UserHistory.vue?vue&type=style&index=0&id=78bbdcf5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78bbdcf5"]])

export default __exports__